import videojs from "video.js";
import "video.js/src/css/video-js.scss"
import {setupErrorScreen} from "./error-screen/error";
import {checkIsOffLine} from "./server-state";

export function setupVideoJS(containerElement, settings) {
    const videoJSOptions = {
        controls: true,
        poster: coverImageUrl(settings),
        muted: settings.muted
    }

    // Clears out all children
    containerElement.innerHTML = ''

    const videoElement = createVideoElement(videoUrl(settings))

    containerElement.appendChild(videoElement)

    // Needs to be in DOM before applying video JS
    const player = videojs(videoElement, videoJSOptions)

    if (settings.autoplay) {
        // Fake a click to make auto-play work more likely
        const onClick = function() {
            player.muted(true)
            player.play().catch(console.error)
            containerElement.removeEventListener("click", onClick)
        }

        containerElement.addEventListener("click", onClick)

        containerElement.click()
    }

    const stopOffLineCheck = checkIsOffLine(settings, showError)

    function showError() {
        player.pause()
        stopOffLineCheck()
        setupErrorScreen(containerElement, settings)
    }

    return player
}

export function createVideoElement(src) {
    // <video id="vid1" className="video-js" data-setup='{}'>
    //     <source src="//vjs.zencdn.net/v/oceans.mp4">
    // </video>

    const video = document.createElement("video")

    video.className = "video-js"

    const source = document.createElement("source")
    source.src = src
    source.type = "application/vnd.apple.mpegurl"

    video.appendChild(source)
    return video
}

export function videoUrl(settings) {
    return `${settings.url}${settings.app}/${settings.key}`
}

export function coverImageUrl(settings) {
    return `${settings.url}${settings.app}/${settings.key}/poster.jpg`
}
